import { buildHeadersWithWidgetToken } from '@elfsight/lib-utils';
import { API_URL } from '../../constants';

export type VoteResponse = {
  code: number;
  message: string;
  payload: {
    pid: string;
  };
};

export async function voteQuery(id: string, widgetToken: string | undefined) {
  const headers = buildHeadersWithWidgetToken(widgetToken, {
    'content-type': 'application/json'
  });

  const response = await fetch(`${API_URL}/api/poll`, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      vote: { id }
    })
  });

  const { code, message, payload }: VoteResponse = await response.json();

  if (code === 401) {
    throw new Error(message);
  }

  return payload;
}
